import { Empty } from '../custom-components/empty';

export function NotificationEmptyState() {
  return (
    <Empty
      className="gap-2 px-2 pb-10 pt-5"
      imageSize={120}
      image="image/upzi/mascot/mascot_profile_thinking_smirk.png"
      title={
        <span className="font-body leading-display-2xs text-display-2xs font-semibold">
          Chưa có hoạt động mới
        </span>
      }
      content={
        <span className="text-on-surface leading-sm text-base">
          Bình yên này... có khi là dấu hiệu cho một cơn bão tin nhắn offer sắp
          tới.
        </span>
      }
    />
  );
}
